const css1 = `
@charset "UTF-8";

*,
*::before,
*::after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote {
    margin: 0;
    padding: 0;
}

/* 当用户点击iOS的Safari浏览器中的链接或JavaScript的可点击的元素时，覆盖显示的高亮颜色 */
html {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
    color: #333;
    font-size: 16px;
    line-height: 1.15;
    font-family: "PingFang", "PingFang SC", "syht", "Microsoft YaHei", "黑体", "宋体", sans-serif;
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
iframe {
    display: block;
}

input,
textarea {
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 16px;
}

b,
strong {
    font-weight: bolder;
}

textarea {
    resize: none;
    font-family: "PingFang", "PingFang SC", "syht", "Microsoft YaHei", "黑体", "宋体", sans-serif;
}

input[type=button],
input[type=submit],
input[type=file],
button {
    cursor: pointer;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
}

button {
    border: none;
    border-radius: 0;
    font-size: 16px;
}

a {
    color: inherit;
}

a:link,
a:visited,
a:hover,
a:active,
a:focus {
    text-decoration: none;
}

ul,
li {
    margin: 0;
}

img {
    -o-object-fit: cover;
    object-fit: cover;
}

img,
video {
    max-width: 100%;
}

table {
    table-layout: fixed;
    max-width: 100%;
}

td {
    word-wrap: break-word;
    width: auto;
    white-space: break-spaces;
}

/* 360浏览器下点击可能会出现黑框 */
.swiper-button-prev,
.swiper-button-next,
.swiper-pagination span {
    outline: none;
}
 `
const css2 = `
.header {
  ...
}
.header-container {
  ...
}
#header {
  ...
}
#header-container {
  ...
}
 `
const css3 = `
&lt;!-- index.html -->
&lt;main id="index">
  &lt;section class="section1">&lt;/section>
  &lt;section class="section2">&lt;/section>
  ...
&lt;/main>

&lt;!-- header -->
&lt;header id="header">
  &lt;div class="header-container">&lt;/div>
&lt;/header>
 `
const css4 = `
&lt;!-- 不建议的样式 -->
.index .section1 .list .item .title {
  ...
}

&lt;!-- 建议的样式 -->
.index .section1 .item-title {
  ...
}
&lt;!-- 或者 -->
.index-section1 .list .item-title {
  ...
}
 `
const css5 = `
&lt;!-- 不建议 -->
&lt;style>
  @import url("more.css");
&lt;/style>

&lt;!-- 建议 -->
&lt;link rel="stylesheet" href="core.css">
 `
const css6 = `
.element { ... }
 `

export default {
  css1,
  css2,
  css3,
  css4,
  css5,
  css6
}